import React from 'react'
import { useSelector } from 'react-redux'
import { isIOS, isMobile, isMacOs } from 'react-device-detect'

import { MenuItem, Select as MaterialSelect } from '@material-ui/core'

import { CONSTANTS, MANAGE_CART_HELPER, PRODUCT_HELPER } from '../../../utils'

const MenuProps = {
	PaperProps: {
		className: `${isIOS || isMacOs ? 'mac-paper-custom-class' : ''} paper-custom-class`,
	},
}

export const Select = ({ name, value, handleChange, returnIOSQtyDropdown }) => (
	<select
		name={name}
		value={value}
		onChange={handleChange}
		className="defaultSelectiOS"
		key={`qtyDropdown-${value}`}
	>
		{returnIOSQtyDropdown()}
	</select>
)

function CartActions({ product }) {
	const { cart_items } = useSelector((state) => state.cart)
	const { maximum_purchase_limit } = useSelector((state) => state.inventory.inventory_settings)
	let cardItem = cart_items.items
	let addedItemIndex = cardItem.findIndex((item) => {
		return (
			item.product.id === product.id &&
			item.product.selected_variant.variant_id === product.selected_variant.variant_id
		)
	})
	let qty = addedItemIndex !== -1 ? cardItem[addedItemIndex].qty : 0
	let maxQty = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(product)

	const [open, setOpen] = React.useState(false)

	const handleOpenQtyDropdown = () => {
		setOpen(true)
	}

	const handleChange = (event) => {
		let quantity = parseInt(event.target.value)
		let operation
		if (quantity < qty && quantity !== 0) {
			operation = CONSTANTS.SUB_QTY
		} else if (quantity === 0) {
			operation = CONSTANTS.DELETE_ITEM
		} else if (quantity > 0) {
			operation = CONSTANTS.ADD_QTY
		}
		PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, operation, quantity)
	}

	const handleCloseQtyDropdown = () => {
		setOpen(false)
	}

	const returnQtyDropdown = () => {
		var rows = []
		for (var i = 0; i <= maxQty; i++) {
			rows.push(
				<MenuItem value={i} key={i}>
					{i}
				</MenuItem>
			)
		}
		return rows
	}

	const returnIOSQtyDropdown = () => {
		var rows = []
		for (var i = 0; i <= maxQty; i++) {
			rows.push(
				<option value={i} key={`qty-dropdown-options-${i}`}>
					{i}
				</option>
			)
		}
		return rows
	}

	return (
		<>
			<div className={`cartActionsWrap ${qty > 0 ? '' : 'd-none'}`} key={product?.id}>
				<button
					className="trashBtn"
					onClick={() => PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.DELETE_ITEM)}
				>
					<i className="icons-icon-trash"></i>
				</button>
				<div className="prodQtyWrap">
					<button
						className="plusMniusQty"
						onClick={() => {
							PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.SUB_QTY, qty - 1)
						}}
						disabled={qty === 1}
					>
						<i className="icons-icon-minus"></i>
					</button>
					<div className="addQtyWrap">
						<div className={`${!isIOS ? '' : ''} insideSelectBox`}>
							{isIOS & isMobile ? (
								<Select
									name="qtyDropdown"
									value={qty}
									handleChange={handleChange}
									returnIOSQtyDropdown={returnIOSQtyDropdown}
								/>
							) : (
								<MaterialSelect
									labelId="demo-controlled-open-select-label"
									id="demo-controlled-open-select"
									open={open}
									onClose={handleCloseQtyDropdown}
									onOpen={handleOpenQtyDropdown}
									value={qty}
									onChange={handleChange}
									MenuProps={MenuProps}
								>
									{returnQtyDropdown()}
								</MaterialSelect>
							)}
						</div>
					</div>
					<button
						className="plusMniusQty"
						onClick={() => {
							let itemAdded = true
							let itemQty = qty + 1
							if (addedItemIndex !== -1) {
								const total_amount =
									cardItem[addedItemIndex].product.selected_variant.price * itemQty
								itemAdded = MANAGE_CART_HELPER.AddCartRule(
									maximum_purchase_limit,
									cardItem[addedItemIndex].product.product_delivery_type,
									total_amount
								)
							}
							if (itemQty <= maxQty && itemAdded) {
								PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, itemQty)
							}
							// else if(itemQty > maxQty){
							//     res.qty = res.qty-1;
							//     itemFound = res;
							//     MANAGE_CART_HELPER.MaxQuantityReached();
							// }
							return true
							// PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, qty+1)
						}}
						disabled={qty >= maxQty}
					>
						<i className="icons-icon-plus"></i>
					</button>
				</div>
			</div>
		</>
	)
}

export default CartActions
